const ChromaticScaleMap = {
  fingers: [
    // These values represent a Chromatic scale with sharps colored black to resemble a piano keyboard
    // 6th string
    [6, 0, { text: "E" }],
    [6, 1, { text: "F" }],
    [6, 2, { text: "F#", textColor: "#FFF", color: "#000" }],
    [6, 3, { text: "G" }],
    [6, 4, { text: "G#", textColor: "#FFF", color: "#000" }],
    [6, 5, { text: "A" }],
    [6, 6, { text: "A#", textColor: "#FFF", color: "#000" }],
    [6, 7, { text: "B" }],
    [6, 8, { text: "C" }],
    [6, 9, { text: "C#", textColor: "#FFF", color: "#000" }],
    [6, 10, { text: "D" }],
    [6, 11, { text: "D#", textColor: "#FFF", color: "#000" }],
    [6, 12, { text: "E" }],
    // 5th string
    [5, 0, { text: "A" }],
    [5, 1, { text: "A#", textColor: "#FFF", color: "#000" }],
    [5, 2, { text: "B" }],
    [5, 3, { text: "C" }],
    [5, 4, { text: "C#", textColor: "#FFF", color: "#000" }],
    [5, 5, { text: "D" }],
    [5, 6, { text: "D#", textColor: "#FFF", color: "#000" }],
    [5, 7, { text: "E" }],
    [5, 8, { text: "F" }],
    [5, 9, { text: "F#", textColor: "#FFF", color: "#000" }],
    [5, 10, { text: "G" }],
    [5, 11, { text: "G#", textColor: "#FFF", color: "#000" }],
    [5, 12, { text: "A" }],
    // 4th string
    [4, 0, { text: "D" }],
    [4, 1, { text: "D#", textColor: "#FFF", color: "#000" }],
    [4, 2, { text: "E" }],
    [4, 3, { text: "F" }],
    [4, 4, { text: "F#", textColor: "#FFF", color: "#000" }],
    [4, 5, { text: "G" }],
    [4, 6, { text: "G#", textColor: "#FFF", color: "#000" }],
    [4, 7, { text: "A" }],
    [4, 8, { text: "A#", textColor: "#FFF", color: "#000" }],
    [4, 9, { text: "B" }],
    [4, 10, { text: "C" }],
    [4, 11, { text: "C#", textColor: "#FFF", color: "#000" }],
    [4, 12, { text: "D" }],
    // 3rd string
    [3, 0, { text: "G" }],
    [3, 1, { text: "G#", textColor: "#FFF", color: "#000" }],
    [3, 2, { text: "A" }],
    [3, 3, { text: "A#", textColor: "#FFF", color: "#000" }],
    [3, 4, { text: "B" }],
    [3, 5, { text: "C" }],
    [3, 6, { text: "C#", textColor: "#FFF", color: "#000" }],
    [3, 7, { text: "D" }],
    [3, 8, { text: "D#", textColor: "#FFF", color: "#000" }],
    [3, 9, { text: "E" }],
    [3, 10, { text: "F" }],
    [3, 11, { text: "F#", textColor: "#FFF", color: "#000" }],
    [3, 12, { text: "G" }],
    // 2nd string
    [2, 0, { text: "B" }],
    [2, 1, { text: "C" }],
    [2, 2, { text: "C#", textColor: "#FFF", color: "#000" }],
    [2, 3, { text: "D" }],
    [2, 4, { text: "D#", textColor: "#FFF", color: "#000" }],
    [2, 5, { text: "E" }],
    [2, 6, { text: "F" }],
    [2, 7, { text: "F#", textColor: "#FFF", color: "#000" }],
    [2, 8, { text: "G" }],
    [2, 9, { text: "G#", textColor: "#FFF", color: "#000" }],
    [2, 10, { text: "A" }],
    [2, 11, { text: "A#", textColor: "#FFF", color: "#000" }],
    [2, 12, { text: "B" }],
    // 1st string
    [1, 0, { text: "E" }],
    [1, 1, { text: "F" }],
    [1, 2, { text: "F#", textColor: "#FFF", color: "#000" }],
    [1, 3, { text: "G" }],
    [1, 4, { text: "G#", textColor: "#FFF", color: "#000" }],
    [1, 5, { text: "A" }],
    [1, 6, { text: "A#", textColor: "#FFF", color: "#000" }],
    [1, 7, { text: "B" }],
    [1, 8, { text: "C" }],
    [1, 9, { text: "C#", textColor: "#FFF", color: "#000" }],
    [1, 10, { text: "D" }],
    [1, 11, { text: "D#", textColor: "#FFF", color: "#000" }],
    [1, 12, { text: "E" }],
  ],
  barres: [],
};

export { ChromaticScaleMap };
